import React from 'react';

import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  useMediaQuery,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { animationFromRight } from '@/components/HomePage/data/animations';

import { MediaQueryAmountsEnum } from '@/enum/mediaQueryAmounts.enum';

import { WebPImage } from '../WebPImage';

/**
 * Component for Supported coins section in Home page
 * @component
 * @example
 * <SupportedCoinsSection />.
 */
const SupportedCoinsSection: React.FC = () => {
  const { t } = useTranslation();
  const [isMobile] = useMediaQuery(MediaQueryAmountsEnum.isMobile);

  return (
    <Container
      display='flex'
      id='supported-coins'
      justifyContent='center'
      maxW='1440px'
      overflow='hidden'
      p={{ base: '82px 30px 60px', lg: '160px 40px' }}
    >
      <Flex
        align={{ base: 'flex-start', lg: 'center' }}
        direction={{ base: 'column', lg: 'row' }}
        justifyContent='space-between'
        w={{ base: '100%', lg: '1440px' }}
      >
        <Box>
          <Heading
            as='h1'
            color='app.pink'
            maxW={isMobile ? '275px' : '100%'}
            size={isMobile ? '2xl' : '3xl'}
          >
            {t('main.supportedCoins.title')}
          </Heading>

          <Box
            background='app.pink'
            h='4px'
            m='20px 0 25px'
            w={{ base: '50px', md: '66px' }}
          />

          <Text
            fontSize={isMobile ? '16px' : '20px'}
            m='20px 0 45px'
            maxW={isMobile ? '100%' : '247px'}
            w='100%'
          >
            {t('main.supportedCoins.text')}
          </Text>
        </Box>

        <Box
          as={motion.div}
          initial='hidden'
          viewport={{ amount: 0.2 }}
          whileInView='visible'
        >
          <Box
            as={motion.div}
            custom={2}
            ml={{ base: '0px', md: '161px' }}
            variants={animationFromRight}
          >
            <WebPImage
              alt='bitcoin'
              commonPath={!isMobile ? 'images/coins.png' : 'images/coinsMB.png'}
              webpPath={
                !isMobile
                  ? 'images/webp/coins.webp'
                  : 'images/webp/coinsMB.webp'
              }
            />
          </Box>
        </Box>
      </Flex>
    </Container>
  );
};

export default SupportedCoinsSection;
